<div style="
width: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    top: 36px;">
  <!--  <i [class]="'vr-ic_fluent_' + icon + '_24_regular widgetPlaceholderImg'"></i>-->
  <img [ngSrc]="'assets/icons-svgs/ic_fluent_' + icon + '_24_regular.svg'" alt="Keton-logo-inntea-angolo"
       class="cornerImage widgetPlaceholderImg"
       height="600"
       priority
       width="600">
  <div class="flexColumn" style="height: 100%; justify-content: center; align-items: center">
    <span class="widgetPlaceholderText">{{ (dashboardService.isImpersonatingUser() ? "DASHBOARD.WIDGET_NOT_CONFIGURED_OTHER_USER" : "DASHBOARD.WIDGET_NOT_CONFIGURED") | translate }}</span>
    <dx-button
      *ngIf="!dashboardService.isImpersonatingUser()"
      (onClick)="configurationCallback.emit(); $event.event!.stopPropagation(); $event.event!.preventDefault();"
      [elementAttr]="{class:'outlinedRedButton'}"
      [height]="36"
      [type]="'default'"
      [width]="160"
      class="raised-button gridster-item-content"
      hint="{{'BUTTONS.CONFIGURE_WIDGET' | translate}}">
      <i class="vr-ic_fluent_edit_24_regular" style="margin: 5px"></i>
      <span>{{ 'BUTTONS.CONFIGURE_WIDGET' | translate }}</span>
    </dx-button>
  </div>
</div>
